module.exports = __webpack_public_path__ + "img/wxPay.b0b17b87.png";